const COURSES_ANNOUNCEMENTS_ROUTE_PREFIX = '/courses/announcements'

export function isCoursesAnnouncementsRoutePath(path?: string): boolean {
  if (!path) return false
  return path === COURSES_ANNOUNCEMENTS_ROUTE_PREFIX || path.startsWith(`${COURSES_ANNOUNCEMENTS_ROUTE_PREFIX}/`)
}
